export default "__VITE_ASSET__BZxLoul$__"